import axios from "axios";
 
export const BASE_URL = "https://api.lunadesk.ru";
// export const BASE_URL = "http://192.168.0.6:8000";
 
const api = axios.create({
    baseURL: BASE_URL,
    headers: { "Content-Type": "application/json" },
});
 
// ── Прокидываем токен из localStorage ────────────────────────────────────────
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("auth_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
 
// ── Обрабатываем 401 — только если это НЕ запрос логина ──────────────────────
api.interceptors.response.use(
    (res) => res,
    (err) => {
        const isLoginRequest = err.config?.url?.includes("/api/auth/login/");
        if (err.response?.status === 401 && !isLoginRequest) {
            localStorage.removeItem("auth_token");
            window.location.reload();
        }
        return Promise.reject(err);
    }
);
 
export default api;
 
 
// ─── Auth ─────────────────────────────────────────────────────────────────────
 
export async function APILogin(email, password) {
    const res = await api.post("/api/auth/login/", { email, password });
    return res.data;
}
 
export async function APIMe() {
    const res = await api.get("/api/auth/me/");
    return res.data;
}
 
 
// ─── Tasks — Folders ─────────────────────────────────────────────────────────
 
export async function APIGetFolders() {
    const res = await api.get("/tasks/folders/");
    return res.data;
}
 
export async function APICreateFolder(data) {
    const res = await api.post("/tasks/folders/", data);
    return res.data;
}
 
export async function APIUpdateFolder(id, data) {
    const res = await api.patch(`/tasks/folders/${id}/`, data);
    return res.data;
}
 
export async function APIDeleteFolder(id) {
    await api.delete(`/tasks/folders/${id}/`);
}

export async function APIReorderTree(data) {
    const res = await api.post("/tasks/reorder/", data);
    return res.data;
}


 
 
// ─── Tasks — TaskLists ────────────────────────────────────────────────────────
 
export async function APICreateTaskList(folderId, data) {
    const res = await api.post(`/tasks/folders/${folderId}/lists/`, data);
    return res.data;
}

export async function APICreateTaskListRoot(data) {
    const res = await api.post("/tasks/lists/root/", data);
    return res.data;
}
 
export async function APIUpdateTaskList(id, data) {
    const res = await api.patch(`/tasks/lists/${id}/`, data);
    return res.data;
}
 
export async function APIDeleteTaskList(id) {
    await api.delete(`/tasks/lists/${id}/`);
}
 
 
// ─── Tasks — Sections ─────────────────────────────────────────────────────────
 
export async function APICreateSection(listId, data) {
    const res = await api.post(`/tasks/lists/${listId}/sections/`, data);
    return res.data;
}
 
export async function APIUpdateSection(id, data) {
    const res = await api.patch(`/tasks/sections/${id}/`, data);
    return res.data;
}
 
export async function APIDeleteSection(id) {
    await api.delete(`/tasks/sections/${id}/`);
}
 
 
// ─── Tasks — Items ────────────────────────────────────────────────────────────
 
export async function APICreateItem(sectionId, data) {
    const res = await api.post(`/tasks/sections/${sectionId}/items/`, data);
    return res.data;
}
 
export async function APICreateSubtask(parentItemId, data) {
    const res = await api.post(`/tasks/items/${parentItemId}/subtasks/`, data);
    return res.data;
}
 
export async function APIUpdateItem(id, data) {
    const res = await api.patch(`/tasks/items/${id}/`, data);
    return res.data;
}
 
export async function APIDeleteItem(id) {
    await api.delete(`/tasks/items/${id}/`);
}
 
 
// ─── Tasks — Comments ─────────────────────────────────────────────────────────

export async function APIGetComments(itemId) {
    const res = await api.get(`/tasks/items/${itemId}/comments/`);
    return res.data;
}

// data — FormData (multipart, с файлами) ИЛИ обычный объект (JSON, без файлов).
export async function APICreateComment(itemId, data) {
    const isForm = typeof FormData !== "undefined" && data instanceof FormData;
    const res = await api.post(
        `/tasks/items/${itemId}/comments/`,
        data,
        isForm ? { headers: { "Content-Type": "multipart/form-data" } } : undefined,
    );
    return res.data;
}

// Правка комментария: text / is_quoted, догрузка files, открепление remove_attachments.
// data — FormData (если есть файлы) или обычный объект.
export async function APIUpdateComment(commentId, data) {
    const isForm = typeof FormData !== "undefined" && data instanceof FormData;
    const res = await api.patch(
        `/tasks/comments/${commentId}/`,
        data,
        isForm ? { headers: { "Content-Type": "multipart/form-data" } } : undefined,
    );
    return res.data;
}

export async function APIDeleteComment(commentId) {
    await api.delete(`/tasks/comments/${commentId}/`);
}

// Открепить одно вложение комментария.
export async function APIDeleteCommentAttachment(commentId, attachmentId) {
    await api.delete(`/tasks/comments/${commentId}/attachments/${attachmentId}/`);
}
 
 
// ─── Projects ─────────────────────────────────────────────────────────────────
 
export async function APIGetProjects() {
    const res = await api.get("/api/projects/");
    return res.data;
}
 
export async function APIGetProject(id) {
    const res = await api.get(`/api/projects/${id}/`);
    return res.data;
}
 
export async function APICreateProject(data) {
    const res = await api.post("/api/projects/", data);
    return res.data;
}
 
export async function APIUpdateProject(id, data) {
    const res = await api.patch(`/api/projects/${id}/`, data);
    return res.data;
}
 
export async function APIDeleteProject(id) {
    await api.delete(`/api/projects/${id}/`);
}




// ─── Share Links ──────────────────────────────────────────────────────────────

export async function APICreateShareLink(data) {
    const res = await api.post("/tasks/share/create/", data);
    return res.data;
}

export async function APIGetShareLinks(targetType, targetId) {
    const res = await api.get(`/tasks/share/list/?target_type=${targetType}&target_id=${targetId}`);
    return res.data;
}

export async function APIUpdateShareLink(token, data) {
    const res = await api.patch(`/tasks/share/${token}/`, data);
    return res.data;
}

export async function APIDeleteShareLink(token) {
    await api.delete(`/tasks/share/${token}/`);
}

// Публичный — без Bearer токена
export async function APICheckShareLink(token) {
    const res = await axios.get(`${BASE_URL}/tasks/share/${token}/check/`);
    return res.data;
}

export async function APIGetShareData(token) {
    const res = await axios.get(`${BASE_URL}/tasks/share/${token}/data/`);
    return res.data;
}

// ─── Media helper ───────────────────────────────────────────────────────────
// Превращает относительный /media/... в абсолютный. Абсолютные, data:, blob: — не трогает.
export function mediaUrl(u) {
    if (!u) return u;
    if (/^(https?:)?\/\//i.test(u) || u.startsWith("data:") || u.startsWith("blob:")) return u;
    return `${BASE_URL}${u.startsWith("/") ? "" : "/"}${u}`;
}

// Для гостевых запросов — передаём X-Share-Token вместо Bearer
export const guestApi = (shareToken) => axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "X-Share-Token": shareToken,
    },
});